<template>
    <div class="min-h-screen bg-gray-100">
      <!-- Vista para usuarios autenticados -->
      <div v-if="user">
        <SidebarMenu
          :user="user"
          :isMenuOpen="isMenuOpen"
          @toggle-menu="toggleMenu"
          @close-menu="closeMenu"
          @logout="logout"
        />
        
        <div class="md:ml-64">
          <main class="p-4">
            <div class="p-6">
              <div class="flex items-center justify-between mb-6">
                <h1 class="text-2xl font-bold text-gray-900">Términos del Servicio</h1>
              </div>
              
              <div class="prose prose-gray max-w-none">
                <section class="mb-6">
                  <p class="text-gray-700 mb-4 leading-relaxed">
                    Al usar nuestros servicios, aceptas los términos y condiciones aquí descritos. Proveemos acceso a herramientas educativas bajo autorización de cada institución correspondiente. Nos reservamos el derecho de modificar estos términos. 
                  </p>
                </section>
  
                <section class="mb-6">
                  <p class="text-gray-700 mb-4 leading-relaxed">
                    El uso indebido del sistema, como intentos de suplantación, manipulación de datos o acceso no autorizado, está prohibido. 
                  </p>
                </section>
  
                <section class="mb-6">
                  <p class="text-gray-700 mb-4 leading-relaxed">
                    Pueden presentarse actualizaciones o mantenimientos sin previo aviso. El uso continuado del portal estudiantil implica la aceptación de los cambios realizados.
                  </p>
                </section>
              </div>
            </div>
          </main>
        </div>
      </div>
  
      <!-- Vista para usuarios NO autenticados -->
      <div v-else class="min-h-screen">
        <header class="bg-gray-100">
          <div class="max-w-4xl mx-auto px-4 py-6">
            <div class="flex justify-between items-center">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center">
                  <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
                  </svg>
                </div>
                <h1 class="text-2xl font-bold text-gray-800">Servicios del Atlántico</h1>
              </div>
              <button
                @click="goToLogin"
                class="text-white px-4 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <span>Iniciar Sesión</span>
              </button>
            </div>
          </div>
        </header>
  
        <main class="max-w-4xl mx-auto px-4 py-8">
            <div class="bg-white rounded-lg shadow-lg p-6">
              <div class="flex items-center justify-between mb-6">
                <h2 class="text-2xl font-bold text-gray-900">Términos del Servicio</h2>
              </div>
              
              <div class="prose prose-gray max-w-none">
                <section class="mb-6">
                  <p class="text-gray-700 mb-4 leading-relaxed">
                    Al usar nuestros servicios, aceptas los términos y condiciones aquí descritos. Proveemos acceso a herramientas educativas bajo autorización de cada institución correspondiente. Nos reservamos el derecho de modificar estos términos. 
                  </p>
                </section>
  
                <section class="mb-6">
                  <p class="text-gray-700 mb-4 leading-relaxed">
                    El uso indebido del sistema, como intentos de suplantación, manipulación de datos o acceso no autorizado, está prohibido.   
                  </p>
                </section>
  
                <section class="mb-6">
                  <p class="text-gray-700 mb-4 leading-relaxed">
                    Pueden presentarse actualizaciones o mantenimientos sin previo aviso. El uso continuado del portal estudiantil implica la aceptación de los cambios realizados.
                  </p>
                </section>
              </div>
            </div>
        </main>
  
        <!-- Footer -->
        <footer class="mt-12">
          <div class="max-w-4xl mx-auto px-4 py-6">
            <div class="flex flex-col md:flex-row justify-between items-center">
              <div class="flex space-x-6 mt-4 md:mt-0">
                <a href="/terminos-del-servicio" class="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Términos del Servicio
                </a>
                <a href="/politica-de-privacidad" class="text-gray-600 hover:text-gray-900 text-sm transition-colors">
                  Política de Privacidad
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
  
      <!-- Loading state -->
      <div v-if="loading" class="min-h-screen flex items-center justify-center bg-gray-100">
        <div class="text-center">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4"></div>
          <p class="text-gray-600">Cargando...</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import SidebarMenu from '@/components/SidebarMenu.vue';
  
  export default {
    components: {
      SidebarMenu,
    },
    data() {
      return {
        user: null,
        isMenuOpen: false,
        loading: true,
        error: null,
      };
    },
    async created() {
      await this.checkAuthStatus();
    },
    methods: {
      async checkAuthStatus() {
        try {
          // Intentar obtener el usuario autenticado
          const response = await axios.get('/me');
          this.user = response.data.user;
          this.loading = false;
        } catch (error) {
          // Si no está autenticado, no redirigir, solo mostrar la vista pública
          console.log("Usuario no autenticado, mostrando vista pública");
          this.user = null;
          this.loading = false;
        }
      },
      goToLogin() {
        this.$router.push('/login');
      },
      toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
      },
      closeMenu() {
        this.isMenuOpen = false;
      },
      async logout() {
        try {
          // Obtener nuevo token CSRF
          await axios.get('/sanctum/csrf-cookie');
  
          // Esperar un momento para asegurar que la cookie se haya establecido
          await new Promise(resolve => setTimeout(resolve, 100));
  
          // Realizar la petición de logout
          const response = await axios.post('/logout', {}, {
            withCredentials: true,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          });
          
          console.log(response);
          
          // Limpiar cookies locales
          document.cookie.split(";").forEach(function(c) { 
            document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
          });
          
          // Redirigir al login
          this.$router.push('/login');
        } catch (error) {
          console.error('Error al cerrar sesión:', error.response?.data || error);
        }
      }
    }
  };
  </script>